export const features = [
  {
    id: "feat-1",
    title: "AI脚本生成",
    description: "基于先进的AI大模型，输入主题即可快速生成结构完整、逻辑清晰的视频脚本初稿，支持多种视频类型模板。",
    icon: "ri-robot-2-line",
  },
  {
    id: "feat-2",
    title: "智能素材整理",
    description: "AI自动识别视频内容并智能分类标签，支持多维度检索，让海量素材管理变得轻松高效。",
    icon: "ri-folder-upload-line",
  },
  {
    id: "feat-3",
    title: "协作起草",
    description: "支持多人实时协作编辑脚本，评论与批注功能让团队沟通更顺畅，版本管理让每一次修改都有迹可循。",
    icon: "ri-team-line",
  },
  {
    id: "feat-4",
    title: "模板库",
    description: "内置500+专业视频脚本模板，覆盖商业宣传、知识科普、产品介绍、短视频等主流视频类型。",
    icon: "ri-layout-5-line",
  },
  {
    id: "feat-5",
    title: "一键成片大纲",
    description: "从脚本自动生成拍摄分镜和制作清单，包含镜头建议、时长预估和注意事项，让拍摄有条不紊。",
    icon: "ri-clapperboard-line",
  },
  {
    id: "feat-6",
    title: "多格式导出",
    description: "支持导出为PDF、Word、Markdown等格式，无缝对接各类视频制作工具和项目管理平台。",
    icon: "ri-file-transfer-line",
  },
];

export const steps = [
  {
    step: 1,
    title: "输入需求",
    description: "填写视频类型、目标受众和核心信息，AI即刻开始分析需求。",
    icon: "ri-keyboard-line",
  },
  {
    step: 2,
    title: "生成初稿",
    description: "AI自动生成视频脚本框架和内容建议，您可以在线实时编辑优化。",
    icon: "ri-draft-line",
  },
  {
    step: 3,
    title: "匹配素材",
    description: "系统智能推荐匹配的视频素材和音乐，快速完成素材准备。",
    icon: "ri-image-add-line",
  },
  {
    step: 4,
    title: "输出成片",
    description: "一键导出完整的分镜脚本和制作清单，直接进入拍摄制作阶段。",
    icon: "ri-send-plane-line",
  },
];

export const testimonials = [
  {
    id: "test-1",
    name: "张伟",
    role: "独立视频创作者",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20in%20creative%20workspace%2C%20warm%20lighting%2C%20friendly%20expression%2C%20simple%20background&width=80&height=80&seq=avatar-1&orientation=squarish",
    content: "使用17起草视频后，我的脚本撰写效率提升了至少3倍。以前写一个5分钟的脚本需要半天，现在1小时就能完成从策划到初稿的全过程。AI生成的框架非常专业，我只需要根据自己的风格稍作调整即可。",
    rating: 5,
  },
  {
    id: "test-2",
    name: "李婷婷",
    role: "企业品牌经理",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%20in%20office%2C%20warm%20lighting%2C%20confident%20expression%2C%20simple%20background&width=80&height=80&seq=avatar-2&orientation=squarish",
    content: "作为品牌方，我们需要与多个视频制作团队对接需求。17起草视频的协作功能让需求沟通变得前所未有的高效，再也不用担心信息传递过程中的偏差和遗漏。模板库也非常实用。",
    rating: 5,
  },
  {
    id: "test-3",
    name: "王浩然",
    role: "短视频MCN运营",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Asian%20man%2C%20creative%20professional%2C%20warm%20lighting%2C%20friendly%20smile%2C%20simple%20background&width=80&height=80&seq=avatar-3&orientation=squarish",
    content: "我们团队每天需要产出10+条视频内容，素材管理曾经是最头疼的事情。17起草视频的智能素材整理功能简直是救星，现在找素材从以前的半小时缩短到了2分钟。强烈推荐给所有内容创作者！",
    rating: 5,
  },
];

export const faqs = [
  {
    question: "17起草视频适合哪些用户使用？",
    answer: "17起草视频面向所有需要视频内容创作的用户，包括但不限于：独立视频创作者、自媒体运营者、企业品牌团队、广告公司、MCN机构、教育培训机构等。无论您是个人还是团队，都能在平台上找到适合自己的创作方案。",
  },
  {
    question: "AI生成的脚本质量如何？是否需要大量修改？",
    answer: "我们的AI模型经过海量优质视频脚本的训练，生成的脚本在结构完整性、逻辑清晰度和语言流畅性方面都达到了专业水准。通常您只需要进行10%-20%的个性化调整即可使用。而且随着您使用频率的增加，AI会不断学习您的创作风格，生成的脚本会越来越贴合您的需求。",
  },
  {
    question: "支持哪些视频类型的脚本生成？",
    answer: "目前支持超过20种主流视频类型，包括：商业宣传片、产品介绍视频、知识科普、教程类视频、Vlog、短视频内容、品牌故事片、客户证言、招聘视频、活动花絮等。平台内置了500+专业模板，并且每月都在持续更新。",
  },
  {
    question: "平台是否支持团队协作？",
    answer: "是的，17起草视频提供完整的团队协作功能。您可以邀请团队成员加入项目，支持多人同时编辑脚本、添加评论和批注、版本对比和回溯。权限管理功能让不同角色的团队成员拥有适合的操作权限。",
  },
  {
    question: "素材智能整理是如何工作的？",
    answer: "我们的AI系统能够自动分析您上传的视频素材内容，识别场景、人物、物体、情绪等元素，并自动生成多维度的标签。您可以通过关键词、颜色、情绪、场景类型等多种维度快速检索需要的素材片段。",
  },
  {
    question: "免费版和专业版有什么区别？",
    answer: "免费版每月提供10次脚本生成和2GB素材存储空间，适合轻度用户试用。专业版不限脚本生成次数，提供50GB素材存储、团队协作、优先客服支持等高级功能。您可以根据实际需求选择适合的版本。",
  },
];